module.exports = __webpack_public_path__ + "img/ai-buy-no-fit.ed9c8683.png";